export enum contestType {
    ALL = "see all",
    CONTEST = "contests",
    FLYER = "flyers",
    PROMOTION = "promotions",
}

export enum contestStatus {
    ALL = "see all",
    WINNERS = "winners"
}